import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import {
  AnalyzeNettleie,
  Hours,
  Step
} from 'src/app/services/analyse/analyse.types';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-nettleie-analyse',
  templateUrl: './nettleie.component.html',
  styleUrls: ['./nettleie.component.scss']
})
export class NettleieAnalyseComponent implements OnInit {
  analyzedConsumption: AnalyzeNettleie;
  hasNoConfig: boolean = false;
  errorAnalyse: boolean = false;
  valgtAdresse: string;

  loading: boolean = true;
  activeView: 'three' | 'month' = 'month';
  showTable: boolean = false;
  currentStep: Step;
  allSteps: Step[];
  allDayMax: Hours[];
  topThreeDayMax: Hours[];
  netteier: string;
  isBeginningOfNewMonth: boolean = false;
  showTrinnInfo: boolean = false;

  constructor(
    private _alertCtrl: AlertController,
    private _analytics: AnalyticsService,
    private router: Router,
    private modalCtrl: ModalController
  ) {
    const state = this.router.getCurrentNavigation().extras?.state;
    if (state) {
      this.analyzedConsumption = state.analyzedConsumption;
      this.netteier = state.netteier;
      this.hasNoConfig = state.hasNoConfig;
      this.errorAnalyse = state.errorAnalyse;
      this.valgtAdresse = state.valgtAdresse;
    } else {
      this.errorAnalyse = true;
      this.loading = false;
    }
  }

  ngOnInit() {
    this.isBeginningOfNewMonth = new Date().getDate() < 4;
    if (!this.hasNoConfig) {
      this.currentStep = this.analyzedConsumption.current_step;
      this.allSteps = this.analyzedConsumption.steps;
      this.allDayMax = this.analyzedConsumption.hours_daymax;
      this.topThreeDayMax = this.analyzedConsumption.hours_high_three;
    }
    this.loading = false;
  }

  changeActiveView(view: 'three' | 'month') {
    this.activeView = view;
    this._analytics.logEvent_selectContent('analysis_view_' + view);
  }

  async showDaymaxInfo() {
    const alert = await this._alertCtrl.create({
      header: 'Hva er en døgnmaks?',
      message: `<p>Døgnmaks er den <strong>timen med høyest strømforbruk</strong> i løpet av et døgn.</p> 
      <p>Snittet av de tre høyeste døgnmaksene i måneden legger grunnlaget for hvilket nettleietrinn du havner i neste måned (kapasitetsledd).</p>
      <p>De tre timene hentes ikke fra samme døgn. Det betyr at dersom du bruker mye strøm på et og samme døgn er det kun den timen med høyest forbruk som gjelder.</p>`,
      buttons: ['Lukk'],
      mode: 'ios',
      cssClass: 'push-alert'
    });
    await alert.present();
    this._analytics.logEvent_selectContent('analysis_daymax_info');
  }

  toggleTableVisibility() {
    this.showTable = !this.showTable;
    this._analytics.logEvent_selectContent('analysis_show_table');
  }

  goToAnalyse() {
    this.router.navigate(['tabs/analyse']);
  }

  closeModal() {
    this.modalCtrl.dismiss();
    this.showTrinnInfo = false;
  }
}
